import Breadcrumb from "../Component/Breadcrumb";
const Visionmission = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="Vision & Mission"
        breadmid="About"
        breadend="Vision & Mission"
      />
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="vission-mission">
                <h2 className="maintitle">Vision</h2>
                <h4>
                  To promote integral growth of the personality of our students,
                  by giving particular attention to the formation of the heart
                  in order to draw out the best in them.
                </h4>
              </div>
            </div>
            <div className="col-md-4">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/vision.png"
                className="img-fluid"
              ></img>
            </div>
            <div className="col-md-4">
              <div className="vission-mission">
                <h2 className="maintitle">Mission</h2>
                <h4>
                  We believe that every child has the power to develop his/ her
                  potentialities through continuous formation of their
                  conscience, which will enable them to know their rights and
                  duties towards God and the Humanity.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Visionmission;
